<div class="photo-dialog">
    <img [src]="data.photoUrl" alt=""/>
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
    <div class="proof-of-delivery-text">
        <div class="proof-of-delivery-font head">Proof of delivery</div>
        <div class="proof-of-delivery-font date">{{data.deliveryDate}}</div>
    </div>
</div>
